<template>
  <div style="padding: 30px;text-align: left;">
    <div v-if="one">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>My product</el-breadcrumb-item>
        <el-breadcrumb-item>New Asn order</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="width:100%;background: #fff;margin-top:10px">
        <div class="steps">
          <el-steps :active="active" finish-status="success" align-center>
            <el-step title="Fill in the number of warehousing"></el-step>
            <el-step title="Fill in the warehousing information"></el-step>
            <el-step title="Choose value-added services"></el-step>
            <el-step title="Waiting for warehouse storage"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="ban">
        <div style="padding: 15px 0;">
          <span>Pre-package method:</span>
          <el-radio-group v-model="form.resource" @change="packaging">
            <el-radio :label="1">Suntek packaging</el-radio>
            <!-- <el-radio :label="2">Packing yourself</el-radio> -->
          </el-radio-group>
        </div>
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%">
          <el-table-column
            v-for="(item,index) in tableHead"
            :label="item.label"
            :property="item.property"
            :key="index"
          >
            <template slot-scope="scope">
              <div v-if="item.label=='Number of warehousing'">
                <el-input v-model="scope.row[scope.column.property]" @blur="keydownproducts"></el-input>
              </div>
              <div v-else-if="item.label=='Image'">
                <img :src="scope.row[scope.column.property]" min-width="70" height="70">
              </div>
              <div v-else-if="item.label=='Length*width*height cm'" class="lwh">
                <el-input v-model="scope.row[scope.column.property].Length1"></el-input>X
                <el-input v-model="scope.row[scope.column.property].width"></el-input>X
                <el-input v-model="scope.row[scope.column.property].height"></el-input>
              </div>
              <div v-else>{{scope.row[scope.column.property]}}</div>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 10px;">
          <p>
            <el-button @click="Next" style="background:#8989ba;color:#fff;outline: none">Next step</el-button>
            <span style="color: #b0b0b0;font-size:14px">Total: {{Total}} SKU,{{products}} products</span>
          </p>
        </div>
      </div>
    </div>

    <div v-if="two">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>My product</el-breadcrumb-item>
        <el-breadcrumb-item>New Asn order</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="width:100%;background: #fff;margin-top:10px">
        <div class="steps">
          <el-steps :active="active" finish-status="success" align-center>
            <el-step title="Fill in the number of warehousing"></el-step>
            <el-step title="Fill in the warehousing information"></el-step>
            <el-step title="Choose value-added services"></el-step>
            <el-step title="Waiting for warehouse storage"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="ban">
        <el-form ref="twoform" :model="twoform" label-width="280px" @submit.native.prevent>
          <el-form-item label="Reference No">
            <el-input v-model="twoform.Reference" style="width:217px"></el-input>
          </el-form-item>
          <el-form-item label=" Shenzhen warehouse address :">Shenzhen warehouse</el-form-item>

          <el-form-item label="ANS priority :">
            <el-radio-group v-model="twoform.Roboto">
              <el-radio :label="0">Roboto-Regular</el-radio>
              <el-radio :label="1">Urgent</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Unloading party :">
            <el-radio-group v-model="twoform.Unloading">
              <el-radio :label="0">Unloading yourself</el-radio>
              <el-radio :label="1">Suntek unloading</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Arrival method :">
            <el-radio-group v-model="twoform.delivery" @change="delivery">
              <el-radio :label="1">Delivery to your door</el-radio>
              <el-radio :label="2">Third party delivery</el-radio>
              <el-radio :label="3">Third party delivery, no waybill number</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="ofdelivery">
            <template v-for="(item1) in twoform.carrier">
              <el-collapse
                v-model="activeName"
                :key="item1.index"
                :accordion=true
                style="position: relative;"
              >
                <el-collapse-item name="1">
                  <template slot="title">
                    <div
                      style="padding-left: 10px;border-left: 2px solid #8989ba; height: 30px;line-height: 30px;"
                    >Carrier</div>
                    <!-- <i
                      class="el-icon-delete"
                      style="position: absolute;color: red;right: 30px;font-size: 16px;"
                      @click.stop="deletecarrier(item1)"
                    ></i> -->
                  </template>
                  <el-form-item label="Carrier name :" :key="item1.index">
                    <el-select v-model="item1.carriervalue" placeholder="Logistics company name">
                      <el-option
                        v-for="(item,index) in carriername"
                        :key="item"
                        :label="item"
                        :value="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="tracking number :" :key="item1.index">
                    <el-input v-model="item1.trackingnumber" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="Contact :" :key="item1.index">
                    <el-input v-model="item1.Contact" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="Contact number :" :key="item1.index">
                    <el-input v-model="item1.Contactnumber" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="Expected arrival time :" :key="item1.index">
                    <!-- <el-input v-model="item1.arrivaltime"  type="datetime" style="width:217px"></el-input> -->
                    <el-date-picker
                      v-model="item1.arrivaltime"
                      type="date"
                      placeholder="Choose the date and time"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-collapse-item>
              </el-collapse>
            </template>
          </div>
          <div
            v-if="onejs"
            style="padding: 10px; text-align: center;color: #f36a21;font-size: 16px;"
          >Logistics company name !</div>
        </el-form>
        <div style="margin-top: 10px;">
          <!-- <el-button @click="Addcarrier" v-if="ofdelivery">Add carrier</el-button> -->
          <p style="margin-top: 10px;">
            <el-button
              @click="Previous2"
              style="background:#a9a9bc;color:#fff;outline: none"
            >Previous</el-button>
            <el-button @click="Next2" style="background:#8989ba;color:#fff;outline: none">Next step</el-button>
          </p>
        </div>
      </div>
    </div>
    <div v-if="Three">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>My product</el-breadcrumb-item>
        <el-breadcrumb-item>New Asn order</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="width:100%;background: #fff;margin-top:10px">
        <div class="steps">
          <el-steps :active="active" finish-status="success" align-center>
            <el-step title="Fill in the number of warehousing"></el-step>
            <el-step title="Fill in the warehousing information"></el-step>
            <el-step title="Choose value-added services"></el-step>
            <el-step title="Waiting for warehouse storage"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="ban">
        <div style="padding: 15px 0;">
          <el-button
            @click="addservices"
            style="background:#8989ba;color:#fff;outline: none"
          >Add value-added services</el-button>
        </div>

        <el-table :data="tableData3" style="width: 100%" class="expand" @selection-change="handleSelectionChange"  :default-expand-all="true">

          <el-table-column type="expand"  >
            <template slot-scope="props">
              <div  v-if="props.row.SPO_item">
              <el-form label-position="left" inline class="demo-table-expand" v-if="props.row.SPO_item.length>0">
                <el-table :data="props.row.SPO_item" style="width: 100%">
                  <el-table-column prop="spop_desc" label="Value-added service name"></el-table-column>
                  <el-table-column prop="note" label="Service request">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.note"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column prop="note" label="operation">
                    <template slot-scope="scope">
                      <i class="el-icon-delete" style="color:red" @click="delete1(scope,props)"></i>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="selection" width="60" fixed="left"></el-table-column>
          <el-table-column label="Image" prop="id">
            <template slot-scope="scope">
              <img :src="scope.row.image" min-width="70" height="70">
            </template>
          </el-table-column>
          <el-table-column label="SKU" prop="sku"></el-table-column>
          <el-table-column label="English name" prop="desc_en"></el-table-column>
          <el-table-column label="Value-added services" prop="SPO_item">
            <template slot-scope="scope">
              <div v-if="scope.row.SPO_item">
                <span v-if="scope.row.SPO_item.length>0"><span v-for="(spoitem,index) in scope.row.SPO_item" :key="index">{{spoitem.spop_desc}}</span> </span>
                 <span v-else>  <a
                  style="color: #8989ba;cursor: pointer;"
                  @click="addservices1(scope)"
                >Add value-added services</a> </span>
              </div>
              <div v-else>
                <a
                  style="color: #8989ba;cursor: pointer;"
                  @click="addservices1(scope)"
                >Add value-added services</a>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 10px;">
          <p>
            <el-button @click="Return3" style="background:#a9a9bc;color:#fff;outline: none">Return</el-button>
            <el-button @click="Next3" style="background:#8989ba;color:#fff;outline: none">Next step</el-button>
            <a @click="Skip">Skip value-added services</a>
          </p>
        </div>
      </div>
      <el-dialog title="Value-added service list" :visible.sync="dialogTableVisible" center>
        <el-table :data="gridData">
          <el-table-column width="60" fixed="left">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" @change="gridchange(scope.row)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column property="spop_desc" label="Value-added service name"></el-table-column>
          <el-table-column property="spop_value_l" label="Service request"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" style="background:#8989ba;color:#fff;outline: none" @click="dialogRecharge">Recharge</el-button>
        </div>
      </el-dialog>
    </div>

    <div v-if="Four">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>My product</el-breadcrumb-item>
        <el-breadcrumb-item>New Asn order</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="width:100%;background: #fff;margin-top:10px">
        <div class="steps">
          <el-steps :active="active" finish-status="success" align-center>
            <el-step title="Fill in the number of warehousing"></el-step>
            <el-step title="Fill in the warehousing information"></el-step>
            <el-step title="Choose value-added services"></el-step>
            <el-step title="Waiting for warehouse storage"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="ban" style="text-align: center;height:400px;position: relative;">
        <div
          style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;height: 100px;"
        >
          <i class="el-icon-circle-check-outline" style="font-size: 97px;color: #7ec1e1;"></i>
          <p
            style="padding: 10px;"
          >Once the ANS order is created, the warehouse will receive your goods and put them on the shelves according to the ANS list.</p>
         
            <a @click="anslist">View my ANS list</a>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { asnshipping, getspecial, createasn } from "../../api/ans";
import { getproduct, downproduct } from "../../api/product";
import { setItem, getItem } from "../../../utils/locstorage";
import Vue from 'vue'
import store from '@/store'
let example1 = [
  {
    label: "Image",
    property: "image"
  },
  {
    label: "SKU",
    property: "cff_sku"
  },
  {
    label: "English name",
    property: "desc_en"
  },
  {
    label: "Number of warehousing",
    property: "quantity"
  }
];

let example2 = [
  {
    label: "Image",
    property: "image"
  },
  {
    label: "SKU",
    property: "cff_sku"
  },
  {
    label: "English name",
    property: "desc_en"
  },
  {
    label: "Number of warehousing",
    property: "quantity"
  },
  {
    label: "Gross weight KG",
    property: "weight"
  },
  {
    label: "Length*width*height cm",
    property: "size"
  },
  {
    label: "CBM",
    property: "cbm"
  },
  {
    label: "Declared value",
    property: "Declaredvalue"
  }
];
export default {
  data() {
    return {
      sku: "",
      activeName: "1",
      gridData: [],
      Selection: [],
      expand:false,
      one: true,
      two: false,
      Three: false,
      Four: false,
      ofdelivery: true,
      onejs: false,
      dialogTableVisible: false,
      addserv:false,
      services: false,
      active: 1,
      tableHead: example1,
      carriername: "",
      tableData: [],
      form: {
        resource: 1
      },
      Total: "0",
      products: "0",
      twoform: {
        Reference: "",
        region: "",
        Roboto: 0,
        desc: "",
        Unloading: 0,
        delivery: 2,
        carrier: [
          {
            carriervalue: "",
            Contact: "",
            Contactnumber: "",
            arrivaltime: "",
            trackingnumber: ""
          }
        ]
      },
      tableData3: [],
      handleSelecti: ""
    };
  },
  created: function() {},
  mounted() {
    let getItemsize = JSON.parse(getItem("Warehousing"));
    console.log(getItemsize);
    if (getItemsize != null) {
      this.Total = getItemsize.length;
      //this.dormitory=getItemsize
      let param = {
        productid: getItemsize
      };
      getproduct(param)
        .then(response => {
          console.log(response);
          if (response.data.ask == 1) {
            this.tableData = response.data.data;
            this.tableData3 = response.data.data;
            //this.total = Number(response.data.count);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
    asnshipping()
      .then(response => {
        console.log(response);

        if (response.data.ask == 1) {
          console.log(response.data.data);
          this.carriername = response.data.data;
          console.log(this.carriername);
        }
      })
      .catch(error => {
        console.log(error);
      });
    if (this.active == 1) {
      this.one = true;
    }
  },
  methods: {

     setClassName({row, index}){
       console.log(row)
        // 通过自己的逻辑返回一个class或者空

        if(!row.SPO_item){
              //this.expand=false
            return 'expand'
        }else{
           //this.expand=true
           return ''
        }
        //return row.SPO_item ? 'expand' : '';
    },
    anslist(){
     store.dispatch('updatemenu', "/AsnOrder")
     //console.log(store)
     this.$router.push({ path: "/AsnOrder" });
    },
    packaging() {
      console.log(this.form.resource);
      if (this.form.resource == 1) {
        this.tableHead = example1;
      } else if (this.form.resource == 2) {
        this.tableHead = example2;
      }
    },
    Next() {
      console.log(this.tableData);
      let flg;
      for (let i = 0; i < this.tableData.length; i++) {
        if (!/^\+?[1-9]\d*$/.test(this.tableData[i].quantity)) {
          flg = false;
          this.$message.error("Please fill in the correct number.");
          return;
        } else {
          flg = true;
        }
      }

      if (flg) {
        this.active = 2;
        this.one = false;
        this.two = true;
      }
    },
    Next2() {
      console.log(this.twoform.carrier[0].carriervalue);
      console.log(this.twoform.carrier[0].trackingnumber);
      if (this.twoform.delivery == 2) {
        if (
          this.twoform.carrier[0].trackingnumber == "" ||
          this.twoform.carrier[0].carriervalue.toString() == ""
        ) {
          this.$message.error("Please trackingnumber");
        } else {
          this.active = 3;
          this.two = false;
          this.Three = true;
        }
      } else {
        this.active = 3;
        this.two = false;
        this.Three = true;
      }
    },
    Next3() {
      let asn_sku = [];
      let SPO_item = [];
      for (let i = 0; i < this.tableData.length; i++) {
        let param = {
          sku: this.tableData[i].cff_sku,
          quantity: this.tableData[i].quantity
        };
        asn_sku.push(param);
      }
      for (let i = 0; i < this.tableData3.length; i++) {
        if (this.tableData3[i].SPO_item != undefined) {
          for (let j = 0; j < this.tableData3[i].SPO_item.length; j++) {
            let param = {
              sku: this.tableData3[i].cff_sku,
              note: this.tableData3[i].SPO_item[j].note,
              spop_id: this.tableData3[i].SPO_item[j].spop_id
            };
            SPO_item.push(param);
          }
        }
      }
      let deliver_way;
      if (this.twoform.delivery == 3) {
        deliver_way = 2;
      } else {
        deliver_way = this.twoform.delivery;
      }
      let flgl = false;
      if (SPO_item.length > 0) {
        for (let i = 0; i < SPO_item.length; i++) {

          if (SPO_item[i].note != undefined) {
            if(SPO_item[i].note !=""){
                  flgl = true;
            }else {
            flgl = false;
          }
           
          } else {
            flgl = false;
          }
        }
      } else {
        flgl = true;
      }
      if (flgl) {
        let param = {
          asn_sku: JSON.stringify(asn_sku),
          SPO_item: JSON.stringify(SPO_item),
          deliver_way: deliver_way,
          asn_level: this.twoform.Roboto,
          reference_no: this.twoform.Reference,
          un_loading: this.twoform.Unloading,
          tracking_number: this.twoform.carrier[0].trackingnumber,
          supplier: this.twoform.carrier[0].carriervalue,
          contact: this.twoform.carrier[0].Contact,
          phone: this.twoform.carrier[0].Contactnumber,
          preotd: this.twoform.carrier[0].arrivaltime
        };
        createasn(param)
          .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
              this.services = true;
              this.active = 4;
              this.Three = false;
              this.Four = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.$message({
          type: "warning",
          message: "Service request Can not be empty"
        });
      }

      // console.log(JSON.stringify(param));
    },
    Previous2() {
      this.active = 1;
      this.one = true;
      this.two = false;
    },
    Addcarrier() {
      this.twoform.carrier.push({
        carriername: [],
        carriervalue: "",
        Contact: "222",
        Contactnumber: "",
        arrivaltime: ""
      });
    },
    deletecarrier(item) {
      var index = this.twoform.carrier.indexOf(item);
      if (index !== -1) {
        this.twoform.carrier.splice(index, 1);
      }
    },
    delete1(scope, props) {
       console.log(props);
       console.log(scope);
      //var temp = scope.row; //一个新的临时数组
      for (var i = 0; i < props.row.SPO_item.length; i++) {
         if(props.row.SPO_item[i].fi_id==scope.row.fi_id){
           props.row.SPO_item.splice(i,1)
           
         }
      }
   // console.log(temp) ;

     
      console.log(scope);
    },
    delivery() {
      console.log(this.twoform.delivery);
      if (this.twoform.delivery != 2) {
        this.twoform.carrier = [
          {
            carriervalue: "",
            Contact: "",
            Contactnumber: "",
            arrivaltime: ""
          }
        ];

        if (this.twoform.delivery == 3) {
          this.onejs = true;
        } else {
          this.onejs = false;
        }
        this.ofdelivery = false;
      } else {
        this.ofdelivery = true;
        this.onejs = false;
      }
    },
    addservices() {
      this.gridData = [];
      this.addserv=false
      if (this.handleSelecti.length == 0) {
        this.$message.error("Please select the operation object");
      } else {
        this.dialogTableVisible = true;
        getspecial()
          .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
              for (let i = 0; i < response.data.data.data.length; i++) {
                response.data.data.data[i].checked = false;
                this.gridData.push(response.data.data.data[i]);
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    addservices1(scope) {
      this.addserv=true
      console.log(scope);
      this.sku = scope.row.cff_sku;
      this.gridData = [];
      this.dialogTableVisible = true;
      getspecial()
        .then(response => {
          console.log(response);
          if (response.data.ask == 1) {
            for (let i = 0; i < response.data.data.data.length; i++) {
              response.data.data.data[i].checked = false;
              this.gridData.push(response.data.data.data[i]);
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    dialogRecharge() {
      console.log(this.handleSelecti.length);
      console.log(this.gridData);
      
      let val = [];
      for (let i = 0; i < this.gridData.length; i++) {
        if (
          this.gridData[i].checked != undefined &&
          this.gridData[i].checked == true
        ) {
          val.push(this.gridData[i]);
        }
      }
       if(val.length==0){
           this.dialogTableVisible = false;
           return
       }
      if (!this.addserv) {
        for (let i = 0; i < this.tableData3.length; i++) {
          for (let j = 0; j < this.handleSelecti.length; j++) {
            if (this.tableData3[i].cff_sku == this.handleSelecti[j].cff_sku) {
                this.$set(this.tableData3[i], "SPO_item" , JSON.parse(JSON.stringify(val)))
         
            }
          }
          this.dialogTableVisible = false;
        }
       
      } else {
        for (let i = 0; i < this.tableData3.length; i++) {
          if (this.tableData3[i].cff_sku == this.sku) {
             this.$set(this.tableData3[i], "SPO_item" , JSON.parse(JSON.stringify(val)))
          }
          this.dialogTableVisible = false;
        }

      }
    },
    gridchange(row) {
      console.log(row);

      if (row.spop_id == "38" && row.checked == true) {
        for (let i = 0; i < this.gridData.length; i++) {
          if (this.gridData[i].spop_id == "39") {
            console.log("39" + this.gridData[i]);
            this.gridData[i].checked = false;
          }
        }
      } else if (row.spop_id == "39" && row.checked == true) {
        for (let i = 0; i < this.gridData.length; i++) {
          if (this.gridData[i].spop_id == "38") {
            console.log("38" + this.gridData[i]);
            this.gridData[i].checked = false;
          }
        }
      }
    },
    Skip() {
      let asn_sku = [];
      let SPO_item = [];
      for (let i = 0; i < this.tableData.length; i++) {
        let param = {
          sku: this.tableData[i].cff_sku,
          quantity: this.tableData[i].quantity
        };
        asn_sku.push(param);
      }
      let deliver_way;
      if (this.twoform.delivery == 3) {
        deliver_way = 2;
      } else {
        deliver_way = this.twoform.delivery;
      }
      console.log(deliver_way);
      let param = {
        asn_sku: JSON.stringify(asn_sku),
        SPO_item: SPO_item,
        deliver_way: deliver_way,
        asn_level: this.twoform.Roboto,
        reference_no: this.twoform.Reference,
        un_loading: this.twoform.Unloading,
        tracking_number: this.twoform.carrier[0].trackingnumber,
          supplier: this.twoform.carrier[0].carriervalue,
          contact: this.twoform.carrier[0].Contact,
          phone: this.twoform.carrier[0].Contactnumber,
          preotd: this.twoform.carrier[0].arrivaltime
      };
      createasn(param)
        .then(response => {
          if (response.data.ask == 1) {
            this.services = false;
            this.active = 4;
            this.Three = false;
            this.Four = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    Return3() {
      this.active = 2;
      this.Three = false;
      this.two = true;
    },
    keydownproducts() {
      console.log(this.tableData);
      let sum = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        if (!/^\+?[1-9]\d*$/.test(this.tableData[i].quantity)) {
          this.$message.error("Please fill in the correct number.");
          return;
        } else {
          sum += Number(this.tableData[i].quantity);
        }
      }
      this.products = sum;
    },
    handleSelectionChange(val) {
      console.log(val);
      this.handleSelecti = val;
    }
  }
};
</script>
<style>
.steps {
  padding: 30px;
  height: 40px;
  margin: 0 auto;
}
.lwh div {
  width: 30px;
  display: inline-block;
}
.lwh input {
  padding: 0;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 200px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
.expand .el-table__expand-column .cell {
    display: none;
}
</style>





// WEBPACK FOOTER //
// src/components/views/AsnOrder/newans/newans.vue